import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaArrowLeft, FaEye, FaEyeSlash } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { MainLayout } from '../../components/layout'
import { useAuthStore } from '../../store'

const ProfileResetPassword = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { resetPassword, user } = useAuthStore()

  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const [formData, setFormData] = useState({
    email: user?.email || '',
    code: '',
    newPassword: '',
    confirmPassword: '',
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async () => {
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error(t('profile.errors.passwordMismatch'))
      return
    }

    try {
      await resetPassword(formData)
      toast.success(t('profile.messages.passwordChanged'))
      navigate('/profile')
    } catch {
      toast.error(t('profile.errors.resetFailed'))
    }
  }

  return (
    <MainLayout title={t('profile.resetPassword')}>
      <div className="max-w-md mx-auto py-10 space-y-6">
        {/* Back button */}
        <button
          onClick={() => navigate('/profile')}
          className="flex items-center gap-2 text-[#04a3d5] font-medium"
        >
          <FaArrowLeft />
          {t('common.back')}
        </button>
        <h2 className="auth-form__title">{t('auth.resetPassword')}</h2>

        <p className="auth-form__description">{t('auth.enterResetDetails')}</p>

        <input
          name="code"
          placeholder={t('profile.enterCode')}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-xl"
          style={{ border: '1px solid #04a3d5' }}
        />

        <div className="relative">
          <input
            type={showNewPassword ? 'text' : 'password'}
            name="newPassword"
            placeholder={t('profile.newPassword')}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl"
            style={{ border: '1px solid #04a3d5' }}
          />
          <button
            type="button"
            onClick={() => setShowNewPassword(!showNewPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
          >
            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <div className="relative">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            placeholder={t('profile.confirmPassword')}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl"
            style={{ border: '1px solid #04a3d5' }}
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full py-3 rounded-xl font-medium text-white"
          style={{
            backgroundColor: '#04a3d5',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = '#0391c2')
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = '#04a3d5')
          }
        >
          {t('common.save')}
        </button>
      </div>
    </MainLayout>
  )
}

export default ProfileResetPassword
